export const authKeys = {
  all: () => ["auth"],
  requestAccess: () => [...authKeys.all(), "requestAccess"],
  forgotPassword: () => [...authKeys.all(), "forgotPassword"],
  signUp: () => [...authKeys.all(), "signup"]
};
